const updateCriteriaArrayOnAll = (value, criteriaReference) => {
  const criteria = criteriaReference

  const valuesArray = value.split(',').map(val => parseInt(val, 10))

  if (criteria.includes(valuesArray[0])) {
    valuesArray.forEach((val) => {
      const index = criteria.findIndex(i => i === val)
      if (index !== -1) criteria.splice(index, 1)
    })
  } else {
    valuesArray.forEach((val) => {
      if (!criteria.includes(val)) criteria.push(val)
      criteria.sort()
    })
  }

  return criteria
}

export default updateCriteriaArrayOnAll



// WEBPACK FOOTER //
// ./src/logic/updateCriteriaArrayOnAll.js